module.exports = __webpack_public_path__ + "img/total-active-awb-hanging.ec7d63e1.svg";